// Keyboard-only focus ring (theme-wide)
// ---------------------------------------------------------------------------
// :focus-visible also fires on pointer + programmatic focus (text fields per
// spec; WebKit on programmatic focus generally). Track the last input modality
// and stamp any non-keyboard focus with data-pointer-focus — the ring is
// suppressed for it in src/application.css, so it shows only after keyboard
// navigation.
(function () {
  'use strict';

  var keyboard = false;
  var NAV_KEYS = ['Tab', 'Enter', ' ', 'Escape', 'ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];

  document.addEventListener('keydown', function (e) {
    if (NAV_KEYS.indexOf(e.key) !== -1) keyboard = true;
  }, true);

  document.addEventListener('pointerdown', function () { keyboard = false; }, true);

  document.addEventListener('focusin', function (e) {
    if (!keyboard && e.target instanceof Element) e.target.setAttribute('data-pointer-focus', '');
  }, true);

  document.addEventListener('focusout', function (e) {
    if (e.target instanceof Element && e.target.hasAttribute('data-pointer-focus')) {
      e.target.removeAttribute('data-pointer-focus');
    }
  }, true);
})();
